import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDEftBVHbC4_NGsXJ3QnZ0MRfmTrvZDlrE",
    authDomain: "immonline-358ca.firebaseapp.com",
    projectId: "immonline-358ca",
    storageBucket: "immonline-358ca.appspot.com",
    messagingSenderId: "24008938869",
    appId: "1:24008938869:web:5ac4c7e3b198dcd8a0af3c",
}
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app)

export default db;